import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class RegisterEBizChargeCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IRegisterEBizChargeParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'vendor/ebiz';
  public override setParameters(parameters: IRegisterEBizChargeParameters) {
    this._commandBody = parameters;
  }
}

export interface IRegisterEBizChargeParameters extends ICommandParameters {
  subscriptionKey: string;
  securityId: string;
  ebizUserId: string;
  pass: string;
  userId: number;
}
